import md5 from 'md5-js'
import axios from 'axios'
import store from '../store/index'
/* 静态配置常数 */
let config = {
  baseURL: '//open.api.edaijia.cn/',
  openApiURL: '//openapi.edaijia.cn/',
  h5Url: 'https://h5.edaijia.cn/'
}
if (location.href.indexOf('.d.edaijia') !== -1 || location.href.indexOf('localhost') !== -1) {
  config = {
    baseURL: '//open.d.api.edaijia.cn/',
    openApiURL: '//openapi.d.edaijia.cn/',
    h5Url: 'https://h5.d.edaijia.cn/'
  }
}
/* 日期格式化 */
let dateFormat = (date, format) => {
  format = format || 'yyyy-MM-dd hh:mm:ss'
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

/* MD5KEY */
var MD5KEY = '0c09bc02-c74e-11e2-a9da-00163e1210d9'

/* 是否嵌套客户端 */
// let ua = navigator.userAgent
// let isClient = ua.indexOf('Edaijia/') !== -1

/* 截取链接参数 */
let urlGet = () => {
  var args = {}
  var query = location.search.substring(1)
  var pairs = query.split('&')
  for (var i = 0; i < pairs.length; i++) {
    var pos = pairs[i].indexOf('=')
    if (pos === -1) continue
    var argname = pairs[i].substring(0, pos)
    var value = pairs[i].substring(pos + 1)
    value = decodeURIComponent(value)
    args[argname] = value
  }
  return args
}

let showToast = (text) => {
  var div = document.createElement('div')
  div.setAttribute('class', 'container-toast')
  var span = document.createElement('span')
  span.innerHTML = text
  div.appendChild(span)
  document.body.appendChild(div)
  div.style.opacity = 1
  setTimeout(function () {
    document.body.removeChild(div)
  }, 1500)
}

let showLoading = function () {
  document.getElementById('loading').style.display = 'block'
  document.getElementById('loading').style.opacity = 1
}

let hideLoading = function () {
  document.getElementById('loading').style.display = 'none'
}

let changeHistory = function () {
  history.pushState(null, null, document.URL)
  window.addEventListener('popstate', function () {
    // showToast('你点到了')
    history.pushState(null, null, this.document.URL)
  })
}

let showAlertBox = function (content, cb) {
  document.getElementById('alert-box').style.display = 'block'
  document.getElementById('alert-title').innerHTML = '温馨提示'
  document.getElementById('alert-content').innerHTML = content
  document.getElementById('alert-sure').innerHTML = '确定'
  document.getElementById('alert-sure').onclick = function () {
    if (cb) {
      cb()
    }
    hideAlertBox()
  }
}

let hideAlertBox = function () {
  document.getElementById('alert-box').style.display = 'none'
}

/* 获取sig  */
let getSig = (param) => {
  var paramStr = []
  var paramStrSorted = []
  for (var n in param) {
    paramStr.push(n)
  }
  paramStr = paramStr.sort()
  paramStr.forEach(item => {
    paramStrSorted.push(item + param[item])
  })
  var text = MD5KEY + paramStrSorted.join('') + MD5KEY
  return md5(text).slice(0, 30)
}

/* 参数拼接 */
// let stringify = (data) => {
//   var value = ''
//   for (let prop in data) {
//     value += prop + '=' + encodeURIComponent(data[prop]) + '&'
//   }
//   return value.substr(0, value.length - 1)
// }

let isWeixin = function () {
  var ua = navigator.userAgent.toLowerCase()
  if(ua.match(/MicroMessenger/i)=='micromessenger') {//eslint-disable-line
    return true
  } else {
    return false
  }
}

let sigConfig = {
  appkey: '51000031',
  udid: '20000001',
  var: 3,
  channel_src: urlGet().channel || '',
  platform: isWeixin() ? 'weixin' : 'h5'
}

axios.defaults.baseURL = config.baseURL // 设置接口域名

let requestAPI = async (url, param, method = 'GET', hideError) => {
  showLoading()
  param.timestamp = dateFormat(new Date())
  if (store.state.token) {
    param['zm_token'] = store.state.token
  }

  if (store.state.openid) {
    param['open_id'] = store.state.openid
  }
  let sig = getSig({
    ...sigConfig,
    ...param
  })

  try {
    let result = await axios({
      url,
      method,
      params: {
        ...sigConfig,
        sig,
        ...param
      }
    })
    hideLoading()
    const filterUrls = [
      '/oapi/driver/signup/upload',
      '/oapi/driver/booking/book',
      '/oapi/driver/signup/examcheck',
      '/oapi/common/organization',
      '/oapi/report/requestMonitor'
    ]
    if( filterUrls.includes(url) ) {//eslint-disable-line
      return result.data
    }
    if (result.data.code == 0) {//eslint-disable-line
      return result.data
    } else if (!hideError) {
      if (url === '/oapi/driver/signup/getopenid') {
        return result.data
      } else {
        showAlertBox(result.data.message)
      }
    }
  } catch (err) {
    hideLoading()
    showAlertBox(`${url} 请求错误：${err.message}`)
  }
}
export {
  config as globalConfig,
  requestAPI,
  urlGet,
  showToast,
  isWeixin,
  showLoading,
  hideLoading,
  changeHistory,
  showAlertBox
}



// WEBPACK FOOTER //
// ./src/utils/common.js